export default {
  title: "Acción"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5002: { text: "Ocurrió un error en el catálogo de Acción" }
    , WS5002: { text: "Ocurrió un error en el catálogo de Acción" }
    , JS5002: { text: "Ocurrió un error en el catálogo de Acción" }
    , CR5002: { text: "Ocurrió un error en el catálogo de Acción" }
    , UK_Accion: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/accion.js